import translations from './data.json';
import type { Constant } from './types';

import { getMessage, interpolate } from '../i18n/utils';

export function constant(key: Constant, values: Record<string, string> = {}) {
  return interpolate(getMessage(translations, key), values);
}
